<template>
    <div class="row">
        <div class="col" v-if="isLoading">
            <SpeenComponent :isAutomatic="true" :ringWidth="14" :spinnerSize="15" :isverticalAligned="true" />
        </div>
        <template v-else>
            <template v-if="isUserSuperadmin">
                <div class="col"></div>
                <div class="col-4">
                    <div class="card">
                        <div class="card-header">
                            <div class="d-flex justify-content-between align-items-center">
                                <span>Lista de paquetes de permisos</span>
                                <div style="display: flex; align-items: center; justify-content: flex-end">
                                    <div>
                                        <b-button @click="showNewPermissionPackageModal"
                                            variant="success">Crear</b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isLoading" style="padding: 5ch 0;">
                            <SpeenComponent :isAutomatic="true" :ringWidth="14" :spinnerSize="15"
                                :isverticalAligned="true" />
                        </div>
                        <div class="card-body" v-else>
                            <b-form-input v-model="packagePermissionsFilter" id="filter-input"
                                placeholder="Ingrese término de búsqueda"></b-form-input>
                            <br>
                            <b-pagination v-model="packagePermissionsCurrentPage"
                                :total-rows="filteredPackagePermissions ? filteredPackagePermissions.length : 0"
                                :per-page="packagePermissionsPerPage" aria-controls="package-permissions-table"
                                align="center">
                            </b-pagination>
                            <b-table :items="filteredPackagePermissions" :fields="packagePermissionsFields" small
                                striped hover :per-page="packagePermissionsPerPage"
                                :current-page="packagePermissionsCurrentPage" id="package-permissions-table">
                                <template #cell(name)="data">
                                    <div class="list-group-item d-flex justify-content-between align-items-center">
                                        <span>
                                            {{ data.item.name }}
                                        </span>
                                        <div>
                                            <button class="btn btn-success btn-sm"
                                                @click="addPermissionsFromPermissionPackage(data.item.id)"
                                                :class="savePermissionsClass">+</button>
                                            <button class="btn btn-danger btn-sm"
                                                @click="removePermissionsFromPermissionPackage(data.item.id)"
                                                :class="savePermissionsClass">-</button>
                                            <button class="btn btn-warning btn-sm"
                                                @click="editPermissionPackage(data.item.id)"><span
                                                    class="mdi mdi-pencil"></span></button>
                                        </div>
                                    </div>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
                <div class="col"></div>
                <form id="permissions-form" class="col-7" action="">
                    <div class="row">
                        <div class="col">
                            <label for="role" class="form-label">Rol</label>
                            <select name="role" id="role" class="form-control" v-chosen="selectRoleId">
                                <option value="empty-role" selected disabled hidden></option>
                                <option v-for="role in rolesData" :value="role.id">{{ role.name }}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label for="user" class="form-label">Usuario</label>
                            <select name="user" id="user" class="form-control" v-chosen="selectUserId">
                                <option value="empty-user" selected disabled hidden></option>
                                <option v-for="user in usersData" :value="user.id">{{ user.name }}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label for="permission-package" class="form-label">Paquete de permisos</label>
                            <select name="permission-package" id="permission-package" class="form-control"
                                v-chosen="selectPermissionPackageId">
                                <option value="empty-permission-package" selected disabled hidden></option>
                                <option v-for="permissionPackage in permissionPackages" :value="permissionPackage.id">{{
                                    permissionPackage.name }}</option>
                            </select>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <h5>Permisos</h5>
                        <div class="col" style="overflow-y: scroll;height: 40rem;">
                            <div v-for="permission in permissionsData" :key="permission.id"
                                class="form-check form-switch">
                                <input :name="`permissions[]`" :value="permission.id" class="form-check-input"
                                    type="checkbox" :id="`p-${permission.id}`"
                                    :checked="selectedPermissions.includes(permission.id)"
                                    @change="handlePermissionsChange(permission.id, $event.target.checked)"
                                    :disabled="!savePermissionsBool">
                                <label :for="`p-${permission.id}`" class="form-check-label" style="cursor: pointer;">
                                    {{ permission.descrip }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-6">
                            <button class="btn btn-success" :class="savePermissionsClass" type="button"
                                @click="savePermissions">Guardar</button>
                        </div>
                        <div class="col">
                            <button class="btn btn-primary" type="button" @click="grantAllPermissions"
                                :class="savePermissionsClass">Dar
                                todos</button>
                            <button class="btn btn-danger" type="button" @click="revokeAllPermissions"
                                :class="savePermissionsClass">Quitar todos</button>
                        </div>
                    </div>
                </form>
            </template>
            <div class="col"></div>
            <div v-if="showNewPermissionPkgModal" class="modal" id="new-permission-package-modal">
                <div class="modal-dialog modal-md">
                    <div class="modal-content">
                        <div id="new-permission-package-form" action="" method="POST">
                            <div class="modal-header">
                                <h4>Nuevo paquete de permisos</h4>
                                <button @click="closeNewPermissionPackageModal" class="close" type="button"
                                    data-dismiss="modal" aria-label="Close"><span
                                        aria-hidden="true">&times;</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <label for="permission-package-name" class="form-label col-8">Nombre</label>
                                </div>
                                <input type="text" class="form-control" name="name" id="permission-package-name"
                                    v-model="newPermissionPackageName">
                                <div class="row">
                                    <label for="permission-package-description"
                                        class="form-label col-8">Descripción</label>
                                </div>
                                <textarea class="form-control" name="description" id="permission-package-description"
                                    v-model="newPermissionPackageDescription" rows="6"></textarea>
                            </div>
                            <div class="modal-footer">
                                <button id="new-permission-package-save" class="col-4 btn btn-success" type="button"
                                    @click="createPermissionPackage"
                                    :class="saveNewPermissionPackageClass">Guardar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="showEditPermissionPackageModal" class="modal" id="edit-permission-package-modal">
                <div class="modal-dialog modal-md">
                    <div class="modal-content">
                        <div id="edit-permission-package-form" action="" method="POST">
                            <div class="modal-header">
                                <h4>Editar paquete de permisos</h4>
                                <button @click="closeEditPermissionPackageModal" class="close" type="button"
                                    data-dismiss="modal" aria-label="Close"><span
                                        aria-hidden="true">&times;</span></button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <label for="edit-permission-package-name" class="form-label col-8">Nombreeeeeeeeeee</label>
                                </div>
                                <input type="text" class="form-control" name="name" id="edit-permission-package-name"
                                    v-model="editPermissionPackageName">
                                <div class="row">
                                    <label for="edit-permission-package-description"
                                        class="form-label col-8">Descripción</label>
                                </div>
                                <textarea class="form-control" name="description"
                                    id="edit-permission-package-description" v-model="editPermissionPackageDescription"
                                    rows="6"></textarea>
                            </div>
                            <div class="modal-footer">
                                <button id="edit-permission-package-delete" class="col-4 btn btn-danger" type="button"
                                    @click="deletePermissionPackage">Eliminar</button>
                                <button id="edit-permission-package-save" class="col-4 btn btn-success" type="button"
                                    @click="updatePermissionPackage"
                                    :class="saveEditPermissionPackageClass">Guardar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import SpeenComponent from '../../common/components/SpeenComponent.vue';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import { mapGetters } from 'vuex';
export default {
    name: 'PermissionsIndex',
    components: {
        SpeenComponent,
    },
    data() {
        return {
            rolesData: [],
            usersData: [],
            permissionsData: [],
            selectedPermissions: [],
            selectedUsers: [],
            selectedRoles: [],
            permissionPackages: [],
            newRoleName: '',
            isLoading: true,
            selectUserId: 0,
            selectRoleId: 0,
            selectPermissionPackageId: 0,
            newPermissionPackageName: '',
            newPermissionPackageDescription: '',
            editPermissionPackageName: '',
            editPermissionPackageDescription: '',
            editPermissionPackageId: 0,
            packagePermissionsFilter: '',
            packagePermissionsCurrentPage: 1,
            packagePermissionsPerPage: 13,
            packagePermissionsFields: [
                { key: 'name', label: 'Paquete de permisos', sortable: true, class: 'truncate' },
            ],
            showNewPermissionPkgModal: false,
            showEditPermissionPackageModal: false,
        };
    },
    mounted() {
        this.getRolesPermissionsVueData();
    },
    methods: {
        getRolesPermissionsVueData() {
            this.isLoading = true;
            axios.get('/api/vue-data/settings-permissions')
                .then(response => {
                    this.rolesData = response.data.rolesWithPermissionPackages;
                    this.usersData = response.data.users;
                    this.permissionsData = response.data.permissions;
                    this.permissionPackages = response.data.permissionPackages;
                })
                .catch(error => {
                    console.error('Error al obtener datos:', error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        handleRoleChange() {
            this.selectUserId = 0;
            this.selectPermissionPackageId = 0;
            this.$nextTick(() => {
                $("#user").val('').trigger("chosen:updated");
                $("#permission-package").val('').trigger("chosen:updated");
            });
            this.getPermissionsByRole();
        },
        handleUserChange() {
            this.selectRoleId = 0;
            this.selectPermissionPackageId = 0;
            this.$nextTick(() => {
                $("#role").val('').trigger("chosen:updated");
                $("#permission-package").val('').trigger("chosen:updated");
            });
            this.getPermissionsByUser();
        },
        handlePermissionsPackageChange() {
            this.selectRoleId = 0;
            this.selectUserId = 0;
            this.$nextTick(() => {
                $("#role").val('').trigger("chosen:updated");
                $("#user").val('').trigger("chosen:updated");
            });
            this.getPermissionsByPermissionPackage();
        },
        getPermissionsByRole() {
            axios.get(`/api/roles/${this.selectRoleId}/get-permissions`)
                .then(response => {
                    this.selectedPermissions = response.data.map(permission => permission.id);
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        getPermissionsByUser() {
            axios.get(`/api/user/${this.selectUserId}/get-permissions`)
                .then(response => {
                    this.selectedPermissions = response.data.map(permission => permission.id);
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        getPermissionsByPermissionPackage() {
            axios.get(`/api/permission-packages/${this.selectPermissionPackageId}/get-permissions`)
                .then(response => {
                    this.selectedPermissions = response.data.map(permission => permission.id);
                })
                .catch(error => {
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        savePermissions() {
            if (this.selectRoleId !== 0 && this.selectRoleId !== null) {
                this.savePermissionsByRole();
            } else if (this.selectUserId !== 0 && this.selectUserId !== null) {
                this.savePermissionsByUser();
            } else if (this.selectPermissionPackageId !== 0 && this.selectPermissionPackageId !== null) {
                this.savePermissionsByPermissionPackage();
            }
        },
        handlePermissionsChange(permissionId, isChecked) {
            if (isChecked) {
                if (!this.selectedPermissions.includes(permissionId)) {
                    this.selectedPermissions.push(permissionId);
                }
            } else {
                const index = this.selectedPermissions.indexOf(permissionId);
                if (index !== -1) {
                    this.selectedPermissions.splice(index, 1);
                }
            }
        },
        savePermissionsByUser() {
            axios.put(`/api/user/${this.selectUserId}/update-permissions`, {
                permissions: this.selectedPermissions,
            })
                .then(response => {
                    showCustomSuccessSweetAlert('Permisos guardados');
                })
                .catch(error => {
                    console.error('Error al guardar permisos:', error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        savePermissionsByRole() {
            axios.put(`/api/roles/${this.selectRoleId}/update-permissions`, {
                permissions: this.selectedPermissions,
            })
                .then(response => {
                    showCustomSuccessSweetAlert('Permisos guardados');
                })
                .catch(error => {
                    console.error('Error al guardar permisos:', error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        savePermissionsByPermissionPackage() {
            axios.put(`/api/permission-packages/${this.selectPermissionPackageId}/update-permissions`, {
                permissions: this.selectedPermissions,
            })
                .then(response => {
                    showCustomSuccessSweetAlert('Permisos guardados');
                })
                .catch(error => {
                    console.error('Error al guardar permisos:', error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        handleRoleUsersChange(userName, isChecked) {
            if (isChecked) {
                if (!this.selectedUsers.includes(userName)) {
                    this.selectedUsers.push(userName);
                }
            } else {
                const index = this.selectedUsers.indexOf(userName);
                if (index !== -1) {
                    this.selectedUsers.splice(index, 1);
                }
            }
        },
        createPermissionPackage() {
            let newPermissionPackageNameData = {
                name: this.newPermissionPackageName,
                descrip: this.newPermissionPackageDescription
            };
            axios.post('/api/permission-packages/create', newPermissionPackageNameData)
                .then(response => {
                    this.getRolesPermissionsVueData();
                    showCustomSuccessSweetAlert('Paquete de permisos creado');
                    this.closeNewPermissionPackageModal();
                })
                .catch(error => {
                    console.error('Error al crear paquete de permisos:', error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        deletePermissionPackage() {
            Swal.fire({
                title: `¿Estás seguro de eliminar el paquete de permisos?`,
                text: 'No podrás revertir esto',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'red',
                cancelButtonColor: 'gray',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.deletePermissionPackageConfirmed();
                }
            });
        },
        deletePermissionPackageConfirmed() {
            this.closeEditPermissionPackageModal();
            axios.delete(`/api/permission-packages/${this.editPermissionPackageId}/delete`)
                .then(response => {
                    this.getRolesPermissionsVueData();
                    showCustomSuccessSweetAlert('Paquete de permisos eliminado');
                })
                .catch(error => {
                    console.error('Error al eliminar paquete de permisos:', error);
                    showCustomErrorSweetAlert(error.response.data);
                })
        },
        showNewPermissionPackageModal() {
            this.newPermissionPackageName = '';
            this.newPermissionPackageDescription = '';
            this.showNewPermissionPkgModal = true;
        },
        closeNewPermissionPackageModal() {
            this.showNewPermissionPkgModal = false;
        },
        grantAllPermissions() {
            this.selectedPermissions = this.permissionsData.map(permission => permission.id);
        },
        revokeAllPermissions() {
            this.selectedPermissions = [];
        },
        addPermissionsFromPermissionPackage(permissionPackageId) {
            axios.get(`/api/permission-packages/${permissionPackageId}/get-permissions`)
                .then(response => {
                    this.selectedPermissions = [...this.selectedPermissions, ...response.data.map(permission => permission.id)];
                })
                .catch(error => {
                    console.error('Error al obtener permisos del paquete:', error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        removePermissionsFromPermissionPackage(permissionPackageId) {
            axios.get(`/api/permission-packages/${permissionPackageId}/get-permissions`)
                .then(response => {
                    this.selectedPermissions = this.selectedPermissions.filter(permissionId => !response.data.map(permission => permission.id).includes(permissionId));
                })
                .catch(error => {
                    console.error('Error al obtener permisos del paquete:', error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        editPermissionPackage(permissionPackageId) {
            this.editPermissionPackageId = permissionPackageId;
            let permissionPackage = this.permissionPackages.find(permissionPackage => permissionPackage.id === permissionPackageId);
            this.editPermissionPackageName = permissionPackage.name;
            this.editPermissionPackageDescription = permissionPackage.descrip;
            this.showEditPermissionPackageModal = true;
        },
        closeEditPermissionPackageModal() {
            this.showEditPermissionPackageModal = false;
        },
        closeViewPermissionPackageModal() {
            $('#view-permission-package-modal').modal('hide');
        },
        updatePermissionPackage() {
            axios.put(`/api/permission-packages/${this.editPermissionPackageId}/update`, {
                name: this.editPermissionPackageName,
                descrip: this.editPermissionPackageDescription
            })
                .then(response => {
                    this.getRolesPermissionsVueData();
                    showCustomSuccessSweetAlert('Paquete de permisos actualizado');
                    this.closeEditPermissionPackageModal();
                })
                .catch(error => {
                    console.error('Error al actualizar paquete de permisos:', error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        cleanSelectedPermissions() {
            this.selectedPermissions = [];
        },
        cleanSelectedUsers() {
            this.selectedUsers = [];
        },
        cleanSelectedRoles() {
            this.selectedRoles = [];
        },
        cleanSelectedPermissionsIfNonSelected() {
            if ((this.selectRoleId === 0 || this.selectRoleId === null) && (this.selectUserId === 0 || this.selectUserId === null) && (this.selectPermissionPackageId === 0 || this.selectPermissionPackageId === null)) {
                this.cleanSelectedPermissions();
            }
        }
    },
    computed: {
        ...mapGetters(['isUserSuperadmin', 'username']),
        savePermissionsBool() {
            return (this.selectRoleId !== 0 && this.selectRoleId !== null) ||
                (this.selectUserId !== 0 && this.selectUserId !== null) ||
                (this.selectPermissionPackageId !== 0 && this.selectPermissionPackageId !== null);
        },
        savePermissionsClass() {
            return {
                'disabled': !this.savePermissionsBool
            };
        },
        saveNewRoleClass() {
            return {
                'disabled': this.newRoleName.trim() === ''
            };
        },
        saveNewPermissionPackageClass() {
            return {
                'disabled': this.newPermissionPackageName.trim() === '' || this.newPermissionPackageDescription.trim() === ''
            };
        },
        saveEditPermissionPackageClass() {
            return {
                'disabled': this.editPermissionPackageName.trim() === '' || this.editPermissionPackageDescription.trim() === ''
            };
        },
        filteredPackagePermissions() {
            if (!this.packagePermissionsFilter) return this.permissionPackages;
            let searchTerm = this.packagePermissionsFilter.toLowerCase();
            return this.permissionPackages.filter(user =>
                Object.values(user).some(value => {
                    if (typeof value === 'object' && value !== null) {
                        return Object.values(value).some(subValue =>
                            String(subValue).toLowerCase().includes(searchTerm)
                        );
                    } else {
                        return String(value).toLowerCase().includes(searchTerm);
                    }
                })
            )
        },
    },
    watch: {
        selectPermissionPackageId() {
            this.cleanSelectedPermissionsIfNonSelected();
            if (this.selectPermissionPackageId == 0 || this.selectPermissionPackageId == null) return;
            this.handlePermissionsPackageChange();
        },
        selectRoleId() {
            this.cleanSelectedPermissionsIfNonSelected();
            if (this.selectRoleId == 0 || this.selectRoleId == null) return;
            this.handleRoleChange();
        },
        selectUserId() {
            this.cleanSelectedPermissionsIfNonSelected();
            if (this.selectUserId == 0 || this.selectUserId == null) return;
            this.handleUserChange();
        },
    }
};
</script>